var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 7.25C10.5523 7.25 11 6.80228 11 6.25C11 5.69772 10.5523 5.25 10 5.25C9.44771 5.25 9 5.69772 9 6.25C9 6.80228 9.44771 7.25 10 7.25ZM11 9.75C11 9.19771 10.5523 8.75 10 8.75C9.44771 8.75 9 9.19771 9 9.75V13.75C9 14.3023 9.44771 14.75 10 14.75C10.5523 14.75 11 14.3023 11 13.75V9.75Z",
    fill: "#1972E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSign);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAyMEMxNS41MjI4IDIwIDIwIDE1LjUyMjggMjAgMTBDMjAgNC40NzcxNSAxNS41MjI4IDAgMTAgMEM0LjQ3NzE1IDAgMCA0LjQ3NzE1IDAgMTBDMCAxNS41MjI4IDQuNDc3MTUgMjAgMTAgMjBaTTEwIDcuMjVDMTAuNTUyMyA3LjI1IDExIDYuODAyMjggMTEgNi4yNUMxMSA1LjY5NzcyIDEwLjU1MjMgNS4yNSAxMCA1LjI1QzkuNDQ3NzEgNS4yNSA5IDUuNjk3NzIgOSA2LjI1QzkgNi44MDIyOCA5LjQ0NzcxIDcuMjUgMTAgNy4yNVpNMTEgOS43NUMxMSA5LjE5NzcxIDEwLjU1MjMgOC43NSAxMCA4Ljc1QzkuNDQ3NzEgOC43NSA5IDkuMTk3NzEgOSA5Ljc1VjEzLjc1QzkgMTQuMzAyMyA5LjQ0NzcxIDE0Ljc1IDEwIDE0Ljc1QzEwLjU1MjMgMTQuNzUgMTEgMTQuMzAyMyAxMSAxMy43NVY5Ljc1WiIgZmlsbD0iIzE5NzJFNiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };